import { useState } from 'react';
import Editor from 'components/CKEditor/Editor';
import EquationBox from './Blocks/EquationBox';
import { AppRadioBox } from 'components';
import useManageTopicSprint from 'hooks/API/useManageTopicSprint';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import useGetSprints from 'hooks/API/GET/useGetSprints';
import SprintList from './SprintList';
import { notifier } from 'components/Toaster';

function TopicSprintTab() {
  const { topicID } = useParams();

  const [content, setContent] = useState('');
  const [sprintType, setSprintType] = useState('');
  const [editingSprintId, setEditingSprintId] = useState(null);

  const { mutate } = useManageTopicSprint({ topicId: topicID });
  const { data: sprintData } = useGetSprints({
    topicId: topicID,
    enabled: !!topicID,
  });

  const isEditing = !!editingSprintId;

  /* ---------------- SAVE ---------------- */

  const handleSave = () => {
    if (!sprintType) return;

    if (isEditing) {
      mutate(
        {
          type: 'UPDATE',
          sprintId: editingSprintId,
          data: {
            contentType: sprintType,
            content,
          },
        },
        {
          onSuccess: (data) => {
            let message = data?.data?.data?.message;
            notifier.success(message);
            handleClear();
          },
          onError: (err) => {
            let message = err?.response?.data?.message;
            notifier.err(message);
          },
        }
      );
    } else {
      mutate(
        {
          contentType: sprintType,
          content,
        },
        {
          onSuccess: (data) => {
            let message = data?.data?.data?.message;
            notifier.success(message);
            handleClear();
          },
          onError: (err) => {
            let message = err?.response?.data?.message;
            notifier.err(message);
          },
        }
      );
    }
  };

  /* ---------------- EDIT ---------------- */

  const handleEditSprint = (sprint) => {
    setEditingSprintId(sprint._id);
    setSprintType(sprint.contentType);
    setContent(sprint.content || '');
  };

  /* ---------------- CLEAR ---------------- */

  const handleClear = () => {
    setContent('');
    setSprintType('');
    setEditingSprintId(null);
  };

  /* ---------------- RENDER ---------------- */

  return (
    <div className="container ninty_percent_width p-0 relative">
      {/* Header */}
      <div className="row">
        <div className="col-12 publishheader">
          <h2 className="prime-head p-0 boldtitle">{isEditing ? 'Edit Sprint' : 'Add Sprint'}</h2>
        </div>
      </div>

      {/* Sprint Type */}
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <label className="label d-block">Select Sprint Type *</label>

          <AppRadioBox
            inputProps={{
              name: 'sprintType',
              checked: sprintType === 'text',
              onChange: () => setSprintType('text'),
              disabled: isEditing,
            }}
            labelProps={{ label: 'Text' }}
          />

          <AppRadioBox
            inputProps={{
              name: 'sprintType',
              checked: sprintType === 'equation',
              onChange: () => setSprintType('equation'),
              disabled: isEditing,
            }}
            labelProps={{ label: 'Equation' }}
          />
        </div>
      </div>

      {/* Content Area */}
      {sprintType && (
        <>
          <div className="row relative">
            <div className="col-md-6 col-sm-12 my-3 mx-3">
              {sprintType === 'text' && (
                <Editor
                  key={editingSprintId || 'new'}
                  data={{
                    value: content,
                    onChange: setContent,
                  }}
                />
              )}

              {sprintType === 'equation' && (
                <EquationBox
                  showProcessButton={false}
                  equation={content}
                  setEquation={setContent}
                />
              )}
            </div>
          </div>

          {/* Save Button */}
          <div className="row mt-5 btnsubmitmain __flex-j-c-center">
            <div className="btnTab-foot">
              <button type="button" className="btn btn-primary" onClick={handleClear}>
                Cancel
              </button>
            </div>
            <div className="col-3 btnTab-foot">
              <button type="button" className="btn-right-content save" onClick={handleSave}>
                {isEditing ? 'Update Sprint' : 'Save Sprint'}
              </button>
            </div>
          </div>
        </>
      )}

      <hr className="divider" />

      {/* Sprint List */}
      <SprintList
        sprintData={sprintData?.data?.result || []}
        mutate={mutate}
        onEdit={handleEditSprint}
        editingSprintId={editingSprintId}
      />
    </div>
  );
}

export default TopicSprintTab;
